import { Grid } from '@mui/material';

import TitleBrowser from '@/components/OrderPlacement/OPStep2FileSelection/TitleBrowser/TitleBrowser';
import OPStep2Breadcrumbs from '@/components/OrderPlacement/OPStep2VersionSelection/OP2Step2Breadcrumbs';
import TitleSearchLoadingCard from '@/components/OrderPlacement/OPTitleSearch/TitleSearchLoadingCard';
import ScheduleSelections from '@/components/Focus/AvailsSchedule/NewSchedule/ScheduleSelections';

const OPTitleSearch = () => {
  return (
    <>
      <Grid container spacing={5}>
        <TitleSearchLoadingCard>
          <OPStep2Breadcrumbs />
          <TitleBrowser />
        </TitleSearchLoadingCard>
        <ScheduleSelections />
      </Grid>
    </>
  );
};

export default OPTitleSearch;
